import { render, staticRenderFns } from "./static-text-widget.vue?vue&type=template&id=9db21340&scoped=true"
import script from "./static-text-widget.vue?vue&type=script&lang=js"
export * from "./static-text-widget.vue?vue&type=script&lang=js"
import style0 from "./static-text-widget.vue?vue&type=style&index=0&id=9db21340&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db21340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9db21340')) {
      api.createRecord('9db21340', component.options)
    } else {
      api.reload('9db21340', component.options)
    }
    module.hot.accept("./static-text-widget.vue?vue&type=template&id=9db21340&scoped=true", function () {
      api.rerender('9db21340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/static-text-widget.vue"
export default component.exports